import type { AppModule } from '@hive/core';

import * as routes from './routes.js';

export const UsersModule: AppModule = {
  routes,
};
